<template>
  <ul class="user-banner__menu--bottom">
    <li
      v-for="item in menu"
      :key="item.link + item.title"
      @click="setActive(item.link)"
    >
      <span
        v-if="unreadMessagesCount[item.slug]"
        class="message_badge"
        :class="getClassBadgeLength(unreadMessagesCount[item.slug])"
      >
        {{ unreadMessagesCount[item.slug] }}
      </span>

      <router-link
        :class="{ active: item.active }"
        :to="{ name: item.link }"
      >
        {{ item.title }}
      </router-link>
    </li>
  </ul>
</template>

<script>
import badge from '@/mixins/badge';

export default {
  name: 'UserCabinetMenu',
  mixins: [badge],
  props: {
    menu: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedLink: this.$route.name,
    };
  },
  computed: {
    unreadMessagesCount() {
      return {
        ...this.$store.getters.getUnreadCounts,
        feeds: this.$route.name === 'profileFeed' ? 0 : this.$store.getters.getUnreadCounts.feeds,
        matchmaking: (Number(this.$store.getters.getUnreadBuyerMarketplace) || 0)
          + (Number(this.$store.getters.getUnreadSellerMarketplace) || 0),
      };
    },
  },
  created() {
    this.setActive(this.selectedLink);
  },
  watch: {
    /* eslint-disable func-names */
    '$route.name': function (name) {
      this.selectedLink = name;
      this.setActive(this.selectedLink);
    },
  },
  methods: {
    setDefaultMenu() {
      this.menu.forEach((item) => {
        if (item.link === this.selectedLink) return;
        // eslint-disable-next-line no-param-reassign
        item.active = false;
      });
    },
    setActive(linkName) {
      this.setDefaultMenu();
      let currentMenu = this.menu.find((i) => i.link === linkName);

      if (!currentMenu && this.$route.path.includes('/profile/matchmaking')) {
        currentMenu = this.menu.find((i) => i.slug === 'matchmaking');
      }

      if (currentMenu) currentMenu.active = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-banner__menu--bottom li {
  position: relative;
}

.message_badge {
  &.two {
    width: 30px;
    border-radius: 40%;
  }

  &.three {
    width: 40px;
    border-radius: 40%;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  width: 20px;
  height: 20px;

  position: absolute;
  top: -10px;
  right: -10px;

  background-color: red;
  border-radius: 50%;

  z-index: 2;

  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
</style>
